export const CHECK_IN_ACTION = 'checkin';
export const CHECK_OUT_ACTION = 'checkout';

export const getQrLink = ({ companyId, reservationId, action, token, origin }) => {
  if (!companyId || !reservationId || !action) return '';

  const normalizedAction = action === CHECK_OUT_ACTION ? CHECK_OUT_ACTION : CHECK_IN_ACTION;
  const baseOrigin = origin || (typeof window !== 'undefined' ? window.location.origin : '');
  const tokenPath = token ? `/${token}` : '';

  return `${baseOrigin}/check/${companyId}/${reservationId}/${normalizedAction}${tokenPath}`;
};

export const getCheckInOutState = (reservation, action) => {
  if (action === CHECK_OUT_ACTION) {
    if (reservation?.checkOutStatus === 'checked_out') {
      return { canUpdate: false, reason: 'Este cliente já realizou check-out.' };
    }

    if (reservation?.checkInStatus !== 'checked_in') {
      return { canUpdate: false, reason: 'É necessário realizar o check-in antes do check-out.' };
    }

    return { canUpdate: true, reason: '' };
  }

  if (reservation?.checkInStatus === 'checked_in') {
    return { canUpdate: false, reason: 'Este cliente já realizou check-in.' };
  }

  return { canUpdate: true, reason: '' };
};
